import React from "react";
import "rc-slider/assets/index.css";
import {
    Row,
    Col,
    Label,
} from "reactstrap";
import { connect } from 'react-redux';
import Select from 'react-select';
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { tempLangConverter } from "../../../../helpers/lanugageHelper";


export const LangInputGroup = props => {
    const [selectedLang, setLang] = React.useState('swe')
    const {
        label,
        confirmations,
        languages,
        form,
    } = props;
    const list = confirmations.map(t => { return { value: t.confirmationId, label: t.name } });
    return (
        <div>
            <Row style={{ margin: "0px" }}>
                <Col style={{ padding: 0, paddingLeft: 10 }}>
                    <Label>
                        <SystemLabel name={label} />
                    </Label>
                </Col>
                <Col
                    style={{
                        display: "inline-flex",
                        padding: 0,
                        paddingTop: '4px',
                        flexDirection: "row-reverse"
                    }}
                >
                    {languages.map((u, i) => {
                        return (
                            <span
                                className={u === selectedLang ? "active" : ""}
                                style={{
                                    fontSize: "10px",
                                    margin: "0px 5px",
                                    textTransform: "uppercase",
                                    opacity: u === selectedLang ? 1 : 0.5,
                                    cursor: "pointer"
                                }}
                                onClick={() => setLang(u)}
                                key={i}
                            >
                                <i className={`flag-icon flag-icon-${tempLangConverter(u)}`} />
                            </span>
                        );
                    })}
                </Col>
            </Row>
            <Row style={{ margin: "0px" }}>
                <Col style={{ maxWidth: "100%", padding: "0px", paddingLeft: "10px" }}>
                    <Select
                        options={list}
                        classNamePrefix="jirango-select"
                        className="jirango-select"
                        value={form.emailConfirmationId ? list.find(c => c.value === form.emailConfirmationId) : null}
                    />
                </Col>
            </Row>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        form: state.form,
        languages: state.language.eventCodes,
        confirmations: state.confirmation.confirmationList,
        template: state.template
    };
}

export default connect(mapStateToProps)(LangInputGroup);
